import { AuthConsumer, AuthProvider } from "./shared/contexts/AuthContext";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import AppLayout from "./screens/layout/AppLayout";
import Login from "./screens/auth/login/Login";
import ForgotPassword from "./screens/auth/forgotPassword/ForgotPassword";
import ResetPassword from "./screens/auth/resetPassword/ResetPassword";
import UnsubscribeComponent from './screens/unsubscribe/Unsubscribe';
import { PATH_UNSUBSCRIBE, PATH_HOME, PATH_CONTACT, PATH_LOGIN, PATH_FORGOT_PASSWORD, PATH_RESET_PASSWORD } from "./screens/layout/RouteConstants";
import LandingPage from "./screens/landing/LandingPage";
import ContactPage from "./screens/contact/ContactPage";
import "./App.scss";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AuthConsumer>
          {({ isAuth }) => {
            if (isAuth) {
              return (
                <Routes>
                  <Route path={PATH_HOME} element={<LandingPage />} />
                  <Route path={PATH_CONTACT} element={<ContactPage />} />
                  <Route path={PATH_UNSUBSCRIBE} element={<UnsubscribeComponent />} />
                  <Route path="/*" element={<AppLayout />} />
                </Routes>
              );
            }

            return (
              <Routes>
                <Route path={PATH_LOGIN} element={<Login />} />
                <Route path={PATH_FORGOT_PASSWORD} element={<ForgotPassword />} />
                <Route path={PATH_RESET_PASSWORD} element={<ResetPassword />} />
                <Route path={PATH_UNSUBSCRIBE} element={<UnsubscribeComponent />} />
                <Route path={PATH_HOME} element={<LandingPage />} />
                <Route path={PATH_CONTACT} element={<ContactPage />} />
                <Route path="/*" element={<Navigate to={PATH_LOGIN} />} />
              </Routes>
            );
          }}
        </AuthConsumer>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;